module.exports = __webpack_public_path__ + "img/wedding-ring.ab6e51aa.svg";